<template>
  <div class="container">
    <div class="title">
      <img src="@/assets/spzx.png" alt="">
    </div>
    <template v-if="active === 0">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onReachBottom"
      >
        <div class="left">
          <div class="list" v-for="(item,index) in list" :key="item.id" v-show="index % 2 == 0"
               @click="ditileClick(item)">
            <div class="playIcon">
              <van-image width="100%" radius="10" :src="item.showPic"/>
              <img class="imgIcon" src="../../../assets/play.png" alt="">
            </div>
            <p class="van-ellipsis">{{ item.name }}</p>
          </div>
        </div>
        <div class="right">
          <div class="list list2" v-for="(item,index) in list" :key="index" v-show="index % 2 !== 0"
               @click="ditileClick(item)">
            <div class="playIcon">
              <van-image width="100%" radius="10" :src="item.showPic"/>
              <img class="imgIcon" src="../../../assets/play.png" alt="">
            </div>
            <p class="van-ellipsis">{{ item.name }}</p>
          </div>
        </div>
      </van-list>
    </template>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
import 'swiper/swiper-bundle.css'
import { getPbShortVideoList, getLivePreviewList, getPlaybackList } from '@/api/exhibit'

export default {
  name: 'VideoOnline',
  components: {
  },
  data: () => ({
    active: 0,
    tabs: [{
      id: 0,
      title: '短视频'
    },
    {
      id: 1,
      title: '直播'
    }],
    endTime: 30 * 60 * 60 * 1000,
    swiperOption: {
      slidesPerView: 1.2,
      spaceBetween: 0,
      loop: false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      }
    },
    list: [],
    swiperList: [],
    backList: [],
    loading: false,
    finished: false,
    pageNo: 1
  }),
  mounted () {
    this.listData()
  },
  methods: {
    getTime (time) {
      console.log(time)
      return new Date(time).getTime() - Date.now()
    },
    // 当切换tab的时候重置分页
    tabsChange (name, title) {
      this.list = []
      this.loading = false
      this.finished = false
      this.pageNo = 1
      if (name === 0) {
        this.listData()
      }
      if (name === 1) {
        this.getSwiperList()
        this.getPlaybackList()
      }
    },
    ditileClick (item) {
      // console.log(item)
      // sessionStorage.setItem('videoContent', JSON.stringify({
      //   name: item.name,
      //   shortVideo: item.video
      // }))
      // this.$router.push('/exhibitVideo')
      window.location.href = item.video
    },
    handlePreviewImage (index) {
      ImagePreview({
        images: this.swiperList.map(item => item.clickPic),
        startPosition: index
      })
    },
    async listData () {
      this.loading = true
      if (!this.finished) {
        console.log('@@@@@@@@@@@@@@@@')
        const { result } = await getPbShortVideoList({
          pageNo: this.pageNo++
        })
        this.loading = false
        console.log(result.records)
        this.list = [...this.list, ...result.records]
        this.finished = result.current === result.pages
      }
    },
    onReachBottom () {
      console.log('2222222')
      if (this.list.length !== 0) {
        this.listData()
      }
    },
    async getSwiperList () {
      const { result } = await getLivePreviewList()
      console.log(result)
      this.swiperList = result
    },
    async getPlaybackList () {
      const { result } = await getPlaybackList()
      console.log(result)
      this.backList = result
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  overflow: hidden;
  min-height: 100vh;
  background-color: #F3E6DD;
  .left,
  .right {
    width: 50%;
    display: inline-block;
    vertical-align: top;
  }
  .title {
    text-align: center;
    margin-top: 20px;
    margin-bottom: 20px;
    img {
      width: 70%;
    }
  }
  .list {
    width: 100%;
    padding: 0 4px 0 10px;
    padding-left: 20px;
    box-sizing: border-box;
    p {
      font-size: 15px;
      margin: 8px 0;
      color: #333;
      margin-top: 3px;
    }

    .playIcon {
      position: relative;

      .imgIcon {
        position: absolute;
        width: 20px;
        height: 20px;
        right: 10px;
        bottom: 10px;
      }
    }
  }

  .list2 {
    padding-left: 4px;
    padding-right: 20px;
    .van-ellipsis {
      margin-top: 3px;
    }
  }

  ::v-deep .tab-title {
    font-size: 16px;
  }

  ::v-deep .van-tabs__nav {
    width: 50vw;
    margin: auto;
  }

  ::v-deep .van-tabs__line {
    bottom: 25px;
  }

  ::v-deep .van-tab {
    font-weight: 600;

    &.van-tab--active {
      font-weight: bold;
    }
  }

  .title-icon {
    display: block;
    width: 135px;
    height: 25px;

    &.notice {
      margin: 0 auto 15px;
    }

    &.replay {
      margin: 45px auto 18px;
    }
  }

  .swiper {
    height: 200px;
    width: 100%;

    .swiper-slide {
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      transition: transform 0.8s;

      &:not(.swiper-slide-active) {
        transform: scale(0.9);
      }

      img {
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }

  .time {
    position: absolute;
    top: 10px;
    right: 12px;
    background-color: #67291C;
    border-radius: 10px;
    font-size: 12px;
    line-height: 20px;
    color: #E7D3C8;
    padding: 0 6px;

    .van-count-down {
      color: #E7D3C8;
      font-size: 12px;
    }
  }

  .desc {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
    margin: auto;
    background-color: rgba(46, 30, 27, .3);
    margin-right: 12px;
    border-radius: 0 8px 8px 0;
    height: 98px;
    color: #FEF8F4;
    padding: 10px 3px 12px;
    box-sizing: border-box;

    .top {
      display: flex;
      align-items: center;

      .avatar {
        width: 46px;
        height: 46px;
        border-radius: 50%;
        object-fit: cover;
      }

      .desc-user {
        margin-left: 6px;

        p {
          margin: 0;

          &:first-child {
            line-height: 1.8;
            font-size: 15px;
          }

          &:last-child {
            font-size: 10px;
          }
        }
      }
    }

    .bottom {
      margin-top: 14px;
      font-size: 18px;
    }
  }

  section.replay {
    margin: 10px 13px;
    height: 200px;
    border-radius: 8px;
    overflow: hidden;
    position: relative;

    .desc {
      height: 74px;
      border-radius: 8px;
      margin: 0 12px;
      padding-left: 10px;

      .top {
        .button {
          color: #FEF8F4;
          background-color: #6C3022;
          font-size: 14px;
          line-height: 24px;
          padding: 0 10px;
          border-radius: 12px;
        }
      }
    }
  }
}
</style>
